export default __webpack_public_path__ + "static/media/Upload.02e9200c.svg";